import { webStorage } from '../../config';

export const NewSticker = (props) => {
    let top = props.top
    let right = props.right
    let width = props.width
    return(
        <img style={{position: 'absolute', top: top, right: right, width: width}} src={webStorage + "/stickers/newsticker.png"}></img>
    )
}